import { useMemo } from 'react';

import { Grid } from '@chakra-ui/react';
import ScrollableSectionNavV2 from 'components/RabbitOKRSidePanel/ScrollableSectionNav';

import { SECTIONS } from '../constants/sections';
import { useGetLevelUpDetailsQuery } from '../dataHooks';

export const CompetencyDrawerPanel = () => {
  const { data: competency } = useGetLevelUpDetailsQuery();

  const accessibleSections = useMemo(
    () => SECTIONS.filter(({ isAccessible }) => isAccessible(competency?.isDetailAccessible)),
    [competency]
  );

  return (
    <Grid
      w="100%"
      h="100%"
      gridTemplateColumns="min-content 1fr"
      gridTemplateRows="1fr min-content"
      gridTemplateAreas="'nav content'"
      gap={1}
    >
      <ScrollableSectionNavV2
        options={accessibleSections}
        navContainerStyles={{
          gridArea: 'nav',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
          padding: '4px',
          overflowY: 'auto',
        }}
        sectionContainerStyles={{
          gridArea: 'content',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          borderRadius: '8px',
          overflowY: 'auto',
          overflowX: 'hidden',
          opacity: 1,
          pointerEvents: 'unset',
          gap: '4px',
        }}
      />
    </Grid>
  );
};
